import { FC, ReactElement } from "react";

import { CircularProgress, Stack } from "@mui/material";

type TColor = "primary" | "inherit" | "secondary" | "error" | "info" | "success" | "warning" | undefined;

interface ILoadable {
  children: ReactElement;
  isLoading: boolean;
  color?: TColor;
}

const Loadable: FC<ILoadable> = ({ children, isLoading, color = "primary" }) => {
  if (isLoading) {
    return (
      <Stack justifyContent="center" alignItems="center">
        <CircularProgress color={color} />
      </Stack>
    );
  }

  return <>{children}</>;
};

export default Loadable;
